import showError from "./AppServices";
import notify from "devextreme/ui/notify";

// function base64toBlob(base64Data, contentType) {
//     contentType = contentType || '';
//     var sliceSize = 1024;
//     var byteCharacters = atob(base64Data);
//     var bytesLength = byteCharacters.length;
//     var slicesCount = Math.ceil(bytesLength / sliceSize);
//     var byteArrays = new Array(slicesCount);

//     for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
//         var begin = sliceIndex * sliceSize;
//         var end = Math.min(begin + sliceSize, bytesLength);

//         var bytes = new Array(end - begin);
//         for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
//             bytes[i] = byteCharacters[offset].charCodeAt(0);
//         }
//         byteArrays[sliceIndex] = new Uint8Array(bytes);
//     }
//     return new Blob(byteArrays, { type: contentType });
// }

export default (value) => {
  try {
    if (value.sucesso) {
      const bin = atob(value.report);
      const length = bin.length;
      const arrayBuffer = new ArrayBuffer(length);
      const uintArray = new Uint8Array(arrayBuffer);

      for (let i = 0; i < length; i++) {
        uintArray[i] = bin.charCodeAt(i);
      }

      const fileBlob = new Blob([uintArray], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(fileBlob);

      window.open(fileURL, "_blank");
    } else {
      notify("Relatório não encontrado.", "error");
      showError(value.erros);
      return;
    }
  } catch (err) {
    console.log(err);
  }
};
